import { styled } from "@mui/material/styles";

export const Container = styled("div")(({ theme }) => ({
  flexGrow: 1,
  padding: 0,
  boxShadow:
    "0px 12px 16px -4px rgba(0, 91, 140, 0.10), 0px 4px 6px -2px rgba(0, 91, 140, 0.03), 0px 2px 2px -1px rgba(0, 91, 140, 0.04)",
  border: `2px solid`,
  borderColor: theme.palette.border.tertiary,
  borderRadius: "8px",
  // background: "rgba(33, 31, 69, 1)",
  "& .border-card-heading": {
    display: "flex",
    padding: theme.customSpacing["3xl"],
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      gap: "10px",
      width: "100%",
    },
    "@media (max-width:1080px)": {
      flexDirection: "column",
      gap: "10px",
      width: "100%",
    },
    "& > h2": {
      margin: 0,
      fontSize: "18px",
      // color: "#f3ecff",
      color: "#fff",
      "& > span": {
        fontSize: "14px",
        display: "block",
        fontWeight: "normal",
        opacity: ".7",
        color: "#fff",
      },
    },
  },
  "& .border-card-content": {
    borderTop: `rgba(255,255,255,.1) 1px solid`,
    padding: theme.customSpacing["3xl"],
  },
}));
